import { Button, CircularProgress } from '@material-ui/core'

import { Typography } from '@material-ui/core'

import React from 'react'
import { CustomModal } from '../../../components/common/CustomModal'
import { EDomain } from 'types/migration'
import { MigrationAlert } from './MigrateCompanyProducts/styled'

interface ImportConfirmationModalProps {
  open: boolean
  onClose: () => void
  onImport: (force?: boolean) => void
  isImporting: boolean
  selectedShopCollections: EDomain[]
  importError: boolean
}

export const ImportConfirmationModal = ({
  open,
  onClose,
  onImport,
  isImporting,
  selectedShopCollections,
  importError,
}: ImportConfirmationModalProps) => {
  return (
    <CustomModal open={open} onClose={onClose} size="medium">
      <CustomModal.Header title={'Import data'} />
      <CustomModal.Content>
        <div>
          <Typography>
            <MigrationAlert>
              The following collections will be imported. Make sure all the collections data have
              been exported successfully.
            </MigrationAlert>
            <ul>
              {selectedShopCollections.map((collection) => (
                <li style={{ textTransform: 'capitalize' }} key={collection}>
                  {collection}
                </li>
              ))}
            </ul>
            <br />
            <span style={{ fontWeight: 500 }}>
              Are you sure you want to import the collections? Any data from a previous import will
              be replaced.
            </span>
          </Typography>
        </div>
      </CustomModal.Content>
      <CustomModal.Footer>
        <Button onClick={onClose} className="button-white-and-red-padded" disabled={isImporting}>
          Cancel
        </Button>
        <Button
          onClick={() => onImport()}
          className="button-blue-and-white-padded"
          disabled={isImporting}
        >
          {isImporting ? <CircularProgress style={{ color: 'white' }} size={20} /> : 'Import'}
        </Button>
      </CustomModal.Footer>
    </CustomModal>
  )
}



// WEBPACK FOOTER //
// ./src/containers/Settings/Development/ImportConfirmationModal.tsx